import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

import {
    AdminSingleSectionData,
    AdminSingleSectionDataVariant,
} from '@INTERFACES/admin-api/sections';

import BaseEditor from '@PAGES/admin/edit-section/components/editors/BaseEditor';

function VariantEditor(props: Props) {
    const {
        variant,
        sectionData,
        selectedVersion,
        onEditorChange,
    } = props;

    const { isLandscape } = sectionData;

    // Handle the case where selectedVersion is the "Draft" option (value: 0) which doesn't have a body
    const getInitialValue = () => {
        // selectedVersion is actually the option object { value: number, label: string }
        // If it's the Draft option (value: 0) or doesn't exist, use variant.body
        if (selectedVersion && selectedVersion.value !== 0) {
            // Find the actual version object from the variant's versions array
            const actualVersion = variant.versions.find(v => v.id === selectedVersion.value);
            if (actualVersion && actualVersion.body) {
                return actualVersion.body;
            }
        }
        return variant.body || '';
    };

    return (
        <BaseEditor
            variantKey={variant.variantIndex || `${variant.id}`}
            initialValue={getInitialValue()}
            isLandscape={isLandscape}
            onEditorChange={onEditorChange}
            context="variant-body"
        />
    );
}

VariantEditor.propTypes = {
    onEditorChange: PropTypes.func.isRequired,
};

type VersionOption = {
    value: number;
    label: string;
};

type Props = InferProps<typeof VariantEditor.propTypes> & {
    variant: AdminSingleSectionDataVariant,
    sectionData: AdminSingleSectionData,
    selectedVersion: VersionOption | null,
};

export default VariantEditor;
